<template>
  <div class="wrap">
    <div class="container">
      <el-tabs
        v-model="activeId"
        class="tabs"
        type="border-card"
        style="margin-top: 30px"
      >
        <el-tab-pane
          v-for="item in tabList"
          :key="item.id"
          :label="item.label"
          :name="item.id"
        >
          <div class="main">
            <keep-alive include="chapters">
              <router-view :classInfo="classInfo"></router-view>
            </keep-alive>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { classInfo } from "@/api/class";
import { assistantInfo } from "@/api/assistantMode";
export default {
  name: "classCourse",
  data() {
    return {
      classInfo: {},
      activeId: "1",
      tabList: [
        {
          id: "1",
          label: "目录",
          text: "chapterCount",
          path: "/classCourse/chapters",
          show: true,
        },
        {
          id: "2",
          label: "团队",
          text: "teamCount",
          path: "/classCourse/teams",
          childrenPath: ["/classCourse/teams/teamOperate"],
          show: true,
        },
        {
          id: "3",
          label: "成员",
          text: "studentCount",
          path: "/classCourse/students",
          show: true,
        },
        // {
        //   id: 4,
        //   topLabel: "英雄",
        //   bottomLabel: "榜",
        //   path: "/classCourse/rank",
        //   show: false,
        // },
        {
          id: "5",
          label: "账号",
          // bottomLabel: "号",
          path: "/classCourse/platformaccount",
          show: false,
        },
        {
          id: "6",
          label: "作品圈",
          // bottomLabel: "圈",
          path: "/classCourse/works",
          show: true,
        },
        // {
        //   id: 7,
        //   topLabel: "考",
        //   bottomLabel: "试",
        //   show: true,
        //   path: "/classCourse/exam",
        //   childrenPath: [
        //     "/classCourse/exam/detail",
        //     "/classCourse/exam/makeExam",
        //   ],
        // },
        // {
        //   id: 8,
        //   topLabel: "错题",
        //   bottomLabel: "库",
        //   show: true,
        //   path: "/classCourse/wrongQuestions",
        //   childrenPath: ["/classCourse/wrongQuestions/detail"],
        // },
        // {
        //   id: '10',
        //   topLabel: "项目实战",
        //   // bottomLabel: "实操",
        //   path: "/classCourse/projectPractice",
        //   childrenPath: [
        //     "/classCourse/projectPractice/buildTeam",
        //     "/classCourse/projectPractice/accountLocation",
        //     "/classCourse/projectPractice/accountEstablish",
        //     "/classCourse/projectPractice/copywriting",
        //     "/classCourse/projectPractice/scenario",
        //     "/classCourse/projectPractice/videoShooting",
        //     "/classCourse/projectPractice/videoClip",
        //     "/classCourse/projectPractice/accountOperation",
        //     "/classCourse/projectPractice/roadshow",
        //     "/classCourse/projectPractice/analysis",
        //   ],
        //   show: false,
        // },
        {
          id: "9",
          label: "数据分析",
          // bottomLabel: "评价",
          path: "/classCourse/evaluation",
          childrenPath: [
            "/classCourse/evaluation/knowledge",
            "/classCourse/evaluation/attitude",
            "classCourse/evaluation/skill",
            "classCourse/evaluation/attainment",
          ],
          show: true,
        },
      ],
      assistant: false,
    };
  },
  created() {
    this.isAssistant();
    this.getClassInfo();
    this.setActiveId();
    this.$store.dispatch("getChapterList", { classId: this.$route.query.id });
  },
  watch: {
    $route() {
      this.setActiveId();
    },
    activeId(id) {
      let tab = this.tabList.find((item) => item.id == id);

      this.$router.push({
        path: tab.path,
        query: {
          id: this.$route.query.id,
          courseId: this.$route.query.courseId,
        },
      });
    },
  },
  methods: {
    // 是否助教身份
    isAssistant() {
      assistantInfo(this.$route.query.id).then((res) => {
        if (res.code == 0) {
          this.assistant = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
    // 班级信息
    getClassInfo() {
      // this.$loading.show();
      classInfo(this.$route.query.id).then((res) => {
        // this.$loading.hide();
        if (res.code == 0) {
          // console.log(res);
          this.classInfo = res.data;
          // this.tabList.find((item) => {
          //   return item.id == 6;
          // }).show = res.data.sz;
          this.tabList.find((item) => {
            return item.id == 5;
          }).show = res.data.douyin;
          this.tabList.find((item) => {
            return item.id == 4;
          }).show = !res.data.videoSz;
          this.tabList.find((item) => {
            return item.id == 10;
          }).show = res.data.videoSz;
        } else {
          console.log(res.msg);
        }
      });
    },
    setActiveId() {
      let activeTab = this.tabList.find((item) => {
        return item.path == this.$route.path;
      });
      if (!activeTab) {
        this.tabList.forEach((item) => {
          if (item.childrenPath) {
            if (this.$route.path.indexOf(item.path) != -1) activeTab = item;
          }
        });
      }
      this.activeId = activeTab.id;
    },
    changeTab(id, path) {
      this.activeId = id;
      this.$router.push({
        path,
        query: {
          id: this.$route.query.id,
        },
      });
    },
    goAssistantMode() {
      const { href } = this.$router.resolve({
        path: "/assistantMode",
        query: { id: this.$route.query.id, courseId: this.classInfo.courseId },
      });
      window.open(href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  background-color: #f8f8f8;
  overflow: hidden;
  .container {
    overflow: initial;
  }
  .info_box {
    width: 100%;

    .cover {
      display: inline-block;
      width: 360px;
      height: 240px;
      vertical-align: top;
    }

    .right {
      position: relative;
      display: inline-block;
      padding: 26px 40px;
      width: calc(100% - 360px);
      height: 240px;
      text-align: left;
      color: #fff;
      background: linear-gradient(180deg, #1976f5, #bd4593 100%);

      .assistant_btn {
        position: absolute;
        top: 25px;
        right: 40px;
      }

      .course_title,
      .course_class {
        display: inline-block;
        margin-right: 20px;
        color: #fff;
        font-weight: bold;
        font-size: 24px;
        &.course_class {
          font-size: 20px;
        }
      }

      .desc {
        margin-top: 10px;
        max-height: 65px;
        font-size: 16px;
        text-indent: 2em;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 4px;
          background-color: #f5f5f5;
        }

        &::-webkit-scrollbar-track {
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
          border-radius: 10px;
          background-color: #f5f5f5;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
          background-color: #c8c8c8;
        }
      }
    }
  }

  .back-row {
    margin-top: 10px;
    text-align: left;
  }
  .tabs {
    margin-top: 20px;
    text-align: left;

    .tab {
      display: inline-block;
      padding: 15px 30px;
      margin-right: 10px;
      // width: 79px;
      // height: 100px;
      // line-height: 100px;
      text-align: center;
      color: #333;
      background: #fff;
      border-radius: 10px;
      box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
      vertical-align: bottom;
      transition: all 0.5s ease;
      cursor: pointer;

      &.activeTab {
        color: #fff;
        background: #1976f5;
      }

      &.hide {
        display: none;
      }

      p {
        font-size: 16px;
        height: 20px;

        &.tab_label {
          // margin-bottom: 8px;
          font-weight: bold;
        }

        &.big {
          font-size: 24px;
          font-weight: bold;
        }
      }
    }
  }
  .main {
    margin-top: 10px;
    margin-bottom: 30px;
  }
}
</style>